class SharedPrizes {
    constructor(app) {
        this.app = app;
    }

    claimAll() {
        jQuery(".claim-shared-prizes").attr("onclick", "").slideUp(250);
        this.app.ajax.post("/services/shared-prizes/claim", null, function () {
            $("#list").slideUp(250);
        });
    }
}
